export default {
  'label/title': 'Meu plano',
  'label/payment_method': 'Forma de Pagamento',
  'label/credit_card': 'Cartão de Crédito',
  'label/boleto': 'Boleto ou PIX',
  'label/special': 'Especial',
  'label/inactive': 'Inativo',
  'label/sms_credits': 'Credito restante',
  'action/talk_support': 'Falar com Suporte',
  'action/updated_credit_card': 'Atualizar Cartão',
  'action/cancel_sms_plan': 'Cancelar Plano de SMS',
  'action/request_sms_plan': 'Contratar Plano de SMS',
  'action/change_plan': 'Alterar Plano',
  'action/manage_plan_and_payments': 'Gerenciar Plano e Pagamentos',
  'label/opening_billing': 'Abrindo...',
  'action/pay': 'Pagar',
  'action/cancel_plan': 'Cancelar Assinatura',
  'action/subscribe_again': 'Assinar Novamente',
  'action/see_plans': 'Ver planos',
  // V2
  'label/need_help': 'Precisa de Ajuda?',




  'label/boleto_active_without_charge/title': 'Without charge text here XD',
  'label/boleto_active_without_charge/text_line_1': 'lorem impsum.',
  'label/boleto_active_without_charge/text_line_2': 'lorem impsum lorem impsum',



  'action/request_new_boleto': 'Gerar Novo Boleto',
  'action/view_boleto': 'Ver Boleto',
  'label/plan': 'Plano',

  'label/sms_title': 'SMS',
  'label/sms_credits_2': 'Saldo Restante de SMS',
  'action/details': 'Detalhes',

  'label/boleto_message_days': 'Você receberá um boleto por email, sempre 5 dias antes do vencimento',
  'action/fix_payment_info_problems_label': 'DADOS DE PAGAMENTO',
  'action/fix_payment_info_problems': 'Seus dados de pagamento estão incompletos',
  'action/fix_payment_info_problems_edit': 'Editar',
  // An iOS build in App Store review: the plan's name, nothing about paying
  'store_review/plan': 'Seu plano',
  'store_review/active_text': 'Sua assinatura está ativa.',
  'store_review/inactive_text': 'Sua assinatura não está ativa. Fale com o suporte para regularizar.',
  'store_review/app_store_text': 'Sua assinatura é pela App Store. Para alterar ou cancelar, use a App Store.',
  'store_review/app_store_manage': 'Gerenciar na App Store',
  'store_review/support': 'Falar com o suporte',
  // Meu Plano: the plan card (PlanSummary)
  'summary/your_plan': 'Seu plano',
  'summary/per_month': '/mês',
  'summary/per_year': '/ano',
  'summary/state/active': 'Ativa',
  'summary/state/app_store': 'Ativa',
  'summary/state/app_store_inactive': 'Inativa',
  'summary/state/blocked': 'Conta bloqueada',
  'summary/state/boleto_late': 'Pagamento pendente',
  'summary/state/will_cancel': 'Cancelamento agendado',
  'summary/state/payment_failed': 'Pagamento pendente',
  'summary/state/boleto_open': 'Boleto em aberto',
  'summary/state/boleto_overdue': 'Pagamento pendente',
  'summary/state/canceled': 'Cancelada',
  'summary/state/trial_ended': 'Teste encerrado',
  'summary/state/inactive': 'Inativa',
  'summary/next_charge': 'Próxima cobrança em {0}.',
  'summary/app_store': 'Paga pela App Store.',
  'summary/app_store_inactive': 'Sua assinatura pela App Store não está ativa.',
  'summary/will_cancel': 'Sua assinatura termina em {0}.',
  'summary/payment_failed': 'A assinatura venceu em {0} e o pagamento ainda não foi identificado. Pague para manter sua conta ativa.',
  'summary/payment_failed_nodate': 'O pagamento da assinatura ainda não foi identificado. Pague para manter sua conta ativa.',
  'summary/blocked': 'Sua conta está bloqueada: a assinatura venceu em {0} e o pagamento não foi identificado. Pague para desbloquear.',
  'summary/blocked_nodate': 'Sua conta está bloqueada porque o pagamento não foi identificado. Pague para desbloquear.',
  'summary/boleto_open': 'O boleto de R$ {0} vence em {1}. Se você já pagou, a confirmação leva até 3 dias úteis.',
  'summary/boleto_late': 'A assinatura venceu em {0} e o pagamento ainda não foi identificado. O boleto de R$ {1} vence em {2}.',
  'summary/boleto_overdue': 'O boleto venceu em {0}. Pague agora para manter sua conta ativa.',
  'summary/canceled': 'Sua assinatura está cancelada.',
  'summary/trial_ended': 'Seu período de teste terminou.',
  'summary/inactive': 'Sua assinatura não está ativa. Fale com o suporte para regularizar.',
  'summary/pay_now': 'Pagar agora',
  'summary/deal': 'Detalhes da assinatura',
  'summary/load_error': 'Não conseguimos carregar a sua assinatura. Tente de novo em instantes.',
  'summary/help': 'Dúvidas sobre a sua assinatura?',
  'summary/help_link': 'Falar com o suporte',
  // A blocked account (no active subscription) on the pages it can still open (BlockedAccountNotice)
  'blocked_notice/title': 'Sua assinatura não está ativa',
  'blocked_notice/trial_title': 'Seu período de teste terminou',
  'blocked_notice/dependent_title': 'A assinatura da clínica não está ativa',
  'blocked_notice/settings': 'A agenda, os pacientes e os relatórios voltam quando houver uma assinatura ativa. Enquanto isso, aqui você vê seu perfil, fala com o suporte e pode sair da conta.',
  'blocked_notice/plan': 'A agenda, os pacientes e os relatórios voltam quando houver uma assinatura ativa.',
  'blocked_notice/dependent_settings': 'A agenda, os pacientes e os relatórios voltam quando o responsável pela clínica regularizar a assinatura. Enquanto isso, aqui você vê seu perfil, fala com o suporte e pode sair da conta.',
  'blocked_notice/dependent_plan': 'A agenda, os pacientes e os relatórios voltam quando o responsável pela clínica regularizar a assinatura.',
  // Meu Plano: moving an App Store subscription to the Doutore (AppStoreSwitch, web and Android only)
  'switch/title': 'Assine direto com o Doutore',
  'switch/why': 'Hoje você paga pela App Store. Assinando direto com o Doutore, a cobrança, as faturas e a troca de plano ficam na sua conta do Doutore, sem depender da App Store.',
  'switch/step1_title': 'Cancele a renovação na App Store',
  'switch/step1_text': 'No iPhone: Ajustes › seu nome › Assinaturas › Doutore › Cancelar assinatura. Você continua usando o Doutore até o fim do período já pago.',
  'switch/step1_button': 'Abrir as assinaturas da App Store',
  'switch/step2_title': 'Depois, assine com o Doutore',
  'switch/step2_text': 'Quando o período pago na App Store terminar, fale com a gente e ativamos a sua assinatura direto com o Doutore.',
  'switch/step2_support': 'Falar com o suporte',
};
